import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectedItemsLabel: {
		defaultMessage:
			'{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}',
		id: 'floating-toolbar.selected-items-label',
		description: 'The label for how many items are selected',
	},
	clearAllButton: {
		defaultMessage: 'Clear all',
		id: 'floating-toolbar.clear-all-button',
		description:
			'The label for the floating toolbar X button that clear the selection and close the toolbar',
	},
	selectAllButtonLabel: {
		defaultMessage: 'Select all',
		id: 'floating-toolbar.select-all-button-label',
		description: 'The label for the floating toolbar select all button',
	},
});
